import React from "react";
import FreeAccessAnnouncement from "./FreeAccessAnnouncement";
import useTrialStatusRefresh from "../Hooks/useTrialStatusRefresh";
import ClubBillingNotice from "./ClubBillingNotice";
import { BILLING_ROUTE } from "../routes";
import { isClubAdmin } from "../utility/Utils";
import { getCurrentLoadedBilling } from "../pages/Billing/billingAccessPolicy";

export default function ClubFreeAccessAnnouncement({ user, billingState, onRefreshBilling, pathname }) {
  const billing = getCurrentLoadedBilling(billingState, user?.club?._id);
  const refreshScope = isClubAdmin(user) && user?._id && user?.club?._id
    ? `${user._id}:${user.club._id}` : null;
  useTrialStatusRefresh(refreshScope ? billing : null, onRefreshBilling, {
    scopeKey: refreshScope,
    retry: Boolean(refreshScope && String(billingState?.clubId) === String(user.club._id) &&
      billingState?.error && !billingState?.loading),
    loading: Boolean(refreshScope && String(billingState?.clubId) === String(user.club._id) && billingState?.loading),
  });
  if (!isClubAdmin(user) || !user?._id || billingState?.loading) return null;
  if (!billing) return null;
  if (billing.billingEnabled === false) {
    return <FreeAccessAnnouncement dismissible userId={user._id} />;
  }
  if (billing.billingEnabled !== true) return null;
  // Suppress notices while the Billing route hands off an action or returns.
  if (pathname === BILLING_ROUTE || pathname?.startsWith(`${BILLING_ROUTE}/`)) return null;
  const restricted = ["read_only", "inactive"].includes(billing.billingAccessMode);
  const actionableFullAccess = billing.billingAccessMode === "full" && billing.canViewBilling === true && (
    ["past_due", "unpaid", "incomplete", "paused", "canceled", "incomplete_expired"].includes(billing.status) ||
    (billing.cancelAtPeriodEnd && ["active", "trialing"].includes(billing.status)) ||
    (!billing.trialStartedLocally && ["not_started", "started_no_subscription"].includes(billing.billingState) && billing.nextAction === "checkout")
  );
  if (restricted || actionableFullAccess) {
    return <ClubBillingNotice key={`${user._id}:${billing.clubId}`} billing={billing} onRefreshBilling={onRefreshBilling} />;
  }
  // Active-trial notices and countdowns are now delivered by Intercom.
  // Restriction, payment, cancellation and existing-club notices stay above.
  return null;
}
